import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_system_input = _resolveComponent("ontos-system-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ontos_form_panel = _resolveComponent("ontos-form-panel")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, {
    ref: "base",
    "phone-flush": ""
  }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_ontos_form_panel, {
            key: 0,
            title: _ctx.$tt('workspace-create'),
            "save-disabled": _ctx.isSaving,
            onSave: _ctx.save
          }, {
            controls: _withCtx(() => [
              _createVNode(_component_ontos_header_action, {
                icon: "mdi-arrow-left",
                label: _ctx.$tt('back'),
                to: {name: 'home'}
              }, null, 8, ["label"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_form, { ref: "form" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ontos_system_input, {
                    ref: "input",
                    value: _ctx.system,
                    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.system = $event)),
                    systems: _ctx.systems
                  }, null, 8, ["value", "systems"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }, 8, ["title", "save-disabled", "onSave"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}